module.exports = __webpack_public_path__ + "img/google_play2.1b7f41ec.png";